import _createForOfIteratorHelper from "/var/www/my-advo.cat/www/femida_web_client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
export var deleteActiveInputConnection = function deleteActiveInputConnection(activeInputConnections, source, output) {
  var _iterator = _createForOfIteratorHelper(activeInputConnections),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var activeInputConnection = _step.value;
      if (activeInputConnection[0] === source && activeInputConnection[1] === output) {
        activeInputConnections.delete(activeInputConnection);
        return activeInputConnection;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return null;
};